var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('div',{staticClass:"cover"},[_c('h1',{staticClass:"loading"},[_vm._v("Diskette einwerfen")]),_c('img',{attrs:{"id":"disc","src":require("@/assets/diskette.png")},on:{"click":_vm.triggerFileInput}})]),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.loadFile}})])
}
var staticRenderFns = []

export { render, staticRenderFns }